import { useMemo } from 'react';

import dayjs from 'dayjs';

import type { DateRange } from '@cast/shared-types';
import { adjustRangeForDayGranularity } from '@cast/split-me/utils';

import { useInventoryWorkloadsTimeRangeSelection } from '../../../../_hooks/useInventoryWorkloadsTimeRangeSelection';

export const useNetworkCostAdjustedDateRange = () => {
  const { getRange, timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const range = getRange();

  return useMemo(() => {
    const current: DateRange = [dayjs.utc(range.from), dayjs.utc(range.to)];
    return {
      currentDateRange: current,
      adjustedDateRange: adjustRangeForDayGranularity(current, timeZone, false),
    };
  }, [range.from, range.to, timeZone]);
};
